var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneBlue = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4225 9.44531L10.5175 9.22781C10.2935 9.20151 10.0665 9.2263 9.85345 9.30035C9.64041 9.37439 9.44693 9.49575 9.28753 9.65531L7.90753 11.0353C5.77842 9.95248 4.04787 8.22192 2.96503 6.09281L4.35253 4.70531C4.67503 4.38281 4.83253 3.93281 4.78003 3.47531L4.56253 1.58531C4.52001 1.21945 4.34443 0.88199 4.06921 0.637199C3.79399 0.392407 3.43836 0.257376 3.07003 0.257814H1.77253C0.925031 0.257814 0.22003 0.962813 0.27253 1.81031C0.67003 8.21531 5.79253 13.3303 12.19 13.7278C13.0375 13.7803 13.7425 13.0753 13.7425 12.2278V10.9303C13.75 10.1728 13.18 9.53531 12.4225 9.44531Z",
    fill: "#00106E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-blue.ae67fbdd5c406bf2cdd3516e375b12d9.svg";